import React from 'react';
import { Button, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useAppStore } from '../../store';
import fluxminIcon from '../../assets/images/fluxmin-icon.png';
import updateDialogBg from '../../assets/images/update-dialog-bg.png';

interface AboutModalProps {
  open: boolean;
  onClose: () => void;
  appVersionText: string;
}

export const AboutModal: React.FC<AboutModalProps> = ({
  open,
  onClose,
  appVersionText,
}) => {
  const appName = useAppStore((state) => state.appConfig.appName);

  return (
    <Modal
      open={open}
      centered
      closable={false}
      footer={null}
      width={392}
      destroyOnHidden
      maskClosable
      onCancel={onClose}
      className="main-layout__about-modal"
      styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.4)' } }}
    >
      <div
        className="main-layout__about-modal-shell"
        style={{ backgroundImage: `url(${updateDialogBg})` }}
      >
        <div className="main-layout__about-modal-body">
          <Button
            type="text"
            className="main-layout__about-modal-close"
            icon={<CloseOutlined />}
            aria-label="关闭关于我们弹窗"
            onClick={onClose}
          />
          <div className="main-layout__about-modal-logo">
            <img src={fluxminIcon} alt={appName} className="main-layout__about-modal-logo-image" />
          </div>
          <h3 className="main-layout__about-modal-title">{appName}</h3>
          <p className="main-layout__about-modal-version">
            {appVersionText ? `V${appVersionText}` : 'V--'}
          </p>
          <p className="main-layout__about-modal-description">
            {appName}是一个电商Ai Agent助手，帮助商家完成线索发现、素材分析、货品洞察与日常运营提效。
          </p>
        </div>
      </div>
    </Modal>
  );
};
